import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page13() {
  useEffect(() => {
    document.title = "Маяк — Страница 12"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page11" />
        <ForwardLink href="/page13" />
      </div>

      <p style={{ textAlign: "right" }}>12.</p>
      <p>Дальше...</p>
      <p>Водоросли, мох и слизь окружают его колени.</p>
      <p>Дальше...</p>
      <p>
        Затем, медленно, ОГРОМНОЕ БРЕВНО, сорок футов в длину и все еще покрытое<br/>
        корой, подплывает к нему...
      </p>
      <p>Еще одно бревно...</p>
      <p>И еще одно!</p>
      <p>
        Он смотрит вперед и МОРЕ ПОЛНО БРЕВЕН: БРЕВНА ПЛЫВУТ<br/>
        ПО РЕКЕ. Он хочет бежать, но не может... он все глубже<br/>
        погружается в океан бревен...
      </p>
      <p>
        Он почти по шею в воде... Внезапно, он видит:<br/>
        <u>ТЕЛО ЧЕЛОВЕКА</u>, плавающего лицом вниз в бревнах:<br/>
        НА НЕМ ШЕРСТЯНОЕ ПАЛЬТО МАКИНО И КОЖАННЫЕ САПОГИ<br/>
        С ТОЛСТЫМИ ШИПОВАННЫМИ ПОДОШВАМИ.
      </p>
      <p>
        Рядом плавает какой-то инструмент: ДЕРЕВЯННЫЙ ЧЕРЕНОК<br/>
        С ЗЛОВЕЩИМ ЖЕЛЕЗНЫМ КРЮКОМ на конце (a peavey или “КРЮК”<br/>
        для перемещения бревен вниз по течению реки).
      </p>
      <p>БРЕВНА НАЧИНАЮТ СДАВЛИВАТЬ...</p>
      <p>ТЕЛО ПЛЫВЕТ К МОЛОДОМУ!</p>
      <p>
        МОЛОДОЙ хочет кричать. Он почти полностью погрузился в  воду...<br/>
        СОЛЕНАЯ ВОДА ПОДНИМАЕТСЯ ВЫШЕ РТА, ЕГО КРИКИ ПРЕВРАЩАЮТСЯ<br/>
        В БУЛЬКАНЬЕ!
      </p>
      <p style={{ textAlign: "right" }}>БЫСТРЫЙ ПЕРЕХОД К:</p>
      <p>
        ШИРОКАЯ КАРТИНКА: Под водой, <u>РУСАЛКА</u> плывет изящно --<br/>
        <u>ЗЛОВЕЩЕ</u> -- в направлении к КАМЕРЕ.
      </p>
      <p style={{ textAlign: "right" }}>БЫСТРЫЙ ПЕРЕХОД К:</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КУБРИК – УТРО</p>
      <p>Вода капает на ЛИЦО МОЛОДОГО</p>
      <p>Капает. Капает. Капает.</p>
      <p>Он открыл глаза, испугавшись.</p>
      <p>СТАРИК раздевается перед зеркалом, аккуратно -- он пьян.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Опоясывающий герпес.
      </p>
      <p style={{ textAlign: "right" }}>12.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page11" />
        <ForwardLink href="/page13" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1707871751/the-lighthouse-script/yphzqgsgozplnv7xwoem.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page13;
